import { FC, useEffect } from "react";

interface ErrorProps {
  className?: string;
}

const Error: FC<ErrorProps> = ({ className, children }) => {
  useEffect(() => {
    document.getElementById("error-box")?.focus();
  }, []);

  return (
    <div
      tabIndex={-1}
      id="error-box"
      className={`max-w-md mx-auto top-20 bg-red-200 dark:bg-red-300 dark:text-neutral-900 rounded-lg text-center font-medium h-20 flex items-center justify-center focus:outline-none ${className}`}
    >
      <div>{children}</div>
    </div>
  );
};

export default Error;
